import { render, staticRenderFns } from "./settlementInfo.vue?vue&type=template&id=290cc1e6&scoped=true"
import script from "./settlementInfo.vue?vue&type=script&lang=js"
export * from "./settlementInfo.vue?vue&type=script&lang=js"
import style0 from "./settlementInfo.vue?vue&type=style&index=0&id=290cc1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290cc1e6",
  null
  
)

export default component.exports